import { render, staticRenderFns } from "./main.vue?vue&type=template&id=79f8941e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f8941e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f8941e')) {
      api.createRecord('79f8941e', component.options)
    } else {
      api.reload('79f8941e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=79f8941e&scoped=true", function () {
      api.rerender('79f8941e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-application_rule/main.vue"
export default component.exports